<template>
    <div class="container">
        <div id="advertiser-details">
            <p>
                <advertiser-selector
                    @selection="selectAdvertiser"
                    :advertisers="advertisers"
                ></advertiser-selector>
            </p>
            <p>
                <product-type-selector
                    @selections="updateProductTypes"
                    :productTypes="advertiser.product_types"
                    :advertiser="advertiser"
                ></product-type-selector>
            </p>
        </div>
    </div>
</template>

<script>
import store from './store.js'
import { mapActions, mapGetters } from 'vuex';
import Swal from "sweetalert2";

export default {
  store: store,

  data(){
    return {
        baseUrl: window.Portal.baseUrl
    }
  },

  methods: {
    ...mapActions([
      'fetchAdvertiser',
      'fetchAdvertisers',
      'fetchSessionAdvertiser',
      'impersonateAdvertiser',
      'patchAdvertiserProductTypes'
    ]),

    selectAdvertiser(selectedAdvertiser){
        if(this.advertiser.id !== selectedAdvertiser.id) {
            this.fetchAdvertiser({baseUrl: this.baseUrl, id: selectedAdvertiser.id});
        }
    },

    updateProductTypes(productTypes){
      let advertiser = this.advertiser;
      advertiser.product_types = productTypes;
      this.patchAdvertiserProductTypes({ baseUrl: this.baseUrl, advertiser });

        new Swal({title: 'Success', titleText: 'Product Types saved!', 'type': 'success'});
    }
  },

  computed: {
    ...mapGetters([
      'advertiser',
      'advertisers',
      'loadingAdvertiser',
      'loadingAdvertisers',
    ])
  },

  mounted: function () {
    this.fetchSessionAdvertiser({
      baseUrl: this.baseUrl
    })
    this.fetchAdvertisers({
      baseUrl: this.baseUrl
    })
  }
}
</script>
